(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-studio"] && !Shopify.designMode) return;
  try {
    
const baPricingRoot = document.querySelector('.ba-pricing-studio');
if (baPricingRoot) {
const ORIGINAL_MATERIALS=[{"name": "Sempertex 5” Standard Latex", "pack": 100.0, "cost": 6.0, "unit": 0.06}, {"name": "Sempertex 5” Metallic / Reflex Latex", "pack": 100.0, "cost": 15.0, "unit": 0.15}, {"name": "Sempertex 11” / 12” Standard Latex", "pack": 100.0, "cost": 15.0, "unit": 0.15}, {"name": "Sempertex 11” / 12” Metallic / Reflex Latex", "pack": 50.0, "cost": 15.0, "unit": 0.3}, {"name": "Sempertex 18” Standard Latex", "pack": 25.0, "cost": 10.0, "unit": 0.4}, {"name": "Sempertex 18” Metallic / Reflex Latex", "pack": 15.0, "cost": 26.0, "unit": 1.73}, {"name": "Sempertex 24” Standard Latex", "pack": 10.0, "cost": 18.0, "unit": 1.8}, {"name": "Sempertex 24” Metallic / Reflex Latex", "pack": 10.0, "cost": 37.0, "unit": 3.7}, {"name": "Sempertex 36” Standard Latex", "pack": 2.0, "cost": 6.0, "unit": 3.0}, {"name": "Mylar 14”", "pack": 1.0, "cost": 1.38, "unit": 1.38}, {"name": "Mylar Numbers 34”", "pack": 1.0, "cost": 5.0, "unit": 5.0}, {"name": "Mylar Numbers 53”", "pack": 1.0, "cost": 9.5, "unit": 9.5}, {"name": "Small Bobo Balloons", "pack": 10.0, "cost": 6.3, "unit": 0.63}, {"name": "Medium Bobo Balloons", "pack": 10.0, "cost": 10.5, "unit": 1.05}, {"name": "Large Bobo Balloons", "pack": 10.0, "cost": 20.6, "unit": 2.06}, {"name": "X-Large Bobo Balloons", "pack": 10.0, "cost": 67.5, "unit": 6.75}, {"name": "Animal Print Latex Balloons", "pack": null, "cost": null, "unit": null}];
const ORIGINAL_EXPENSES=[{"name": "Travel / Setup & Delivery", "rate": 150.0, "qty": 1.0}, {"name": "Breakdown", "rate": 75.0, "qty": 1.0}, {"name": "Other", "rate": null, "qty": null}, {"name": "Florals", "rate": 45.0, "qty": 1.0}, {"name": "Vinyl / Decals", "rate": null, "qty": null}, {"name": "Metal Arch Rental", "rate": 35.0, "qty": 2.0}, {"name": "Foam Board Arch Rental", "rate": null, "qty": null}, {"name": "Foam Board Character Rental", "rate": null, "qty": null}];
const $=id=>document.getElementById(id);
const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(Number(n)||0);
const n=id=>parseFloat($(id).value)||0;
const clone=o=>JSON.parse(JSON.stringify(o));
let materialLib=JSON.parse(localStorage.getItem('ba_materialLib_v2')||'null')||clone(ORIGINAL_MATERIALS);
let expenseLib=JSON.parse(localStorage.getItem('ba_expenseLib_v2')||'null')||clone(ORIGINAL_EXPENSES);
let settings=JSON.parse(localStorage.getItem('ba_settings_v2')||'null')||{labor:35,overhead:0,margin:0,minJob:0,minUnit:0,roundTo:10};

function materialOptions(selected=''){return '<option value="">Choose material…</option>'+materialLib.map((m,i)=>`<option value="${i}" ${String(i)===String(selected)?'selected':''}>${m.name}</option>`).join('')}
function expenseOptions(selected=''){return '<option value="">Choose expense…</option>'+expenseLib.map((e,i)=>`<option value="${i}" ${String(i)===String(selected)?'selected':''}>${e.name}</option>`).join('')}

function addJobMaterial(data={}){
 const row=document.createElement('div'); row.className='itemrow';
 row.innerHTML=`<select class="jm-name">${materialOptions(data.idx??'')}</select><input class="jm-pack" type="number" min="0" step=".01" value="${data.pack??''}" placeholder="Pack"><input class="jm-cost" type="number" min="0" step=".01" value="${data.cost??''}" placeholder="$"><input class="jm-used" type="number" min="0" step="1" inputmode="numeric" value="${data.used??0}"><div class="total">$0.00</div><button class="x">×</button>`;
 const sel=row.querySelector('.jm-name');
 sel.addEventListener('change',()=>{let i=sel.value;if(i!==''){let m=materialLib[i];row.querySelector('.jm-pack').value=m.pack??'';row.querySelector('.jm-cost').value=m.cost??''} calculate()});
 row.querySelectorAll('input').forEach(x=>x.addEventListener('input',calculate)); row.querySelector('.x').onclick=()=>{row.remove();calculate()}; $('jobMaterials').appendChild(row); calculate();
}
function addJobExpense(data={}){
 const row=document.createElement('div'); row.className='itemrow';
 row.innerHTML=`<select class="je-name">${expenseOptions(data.idx??'')}</select><input class="je-rate" type="number" min="0" step=".01" value="${data.rate??''}" placeholder="Rate"><input class="je-qty" type="number" min="0" step=".01" value="${data.qty??1}"><div></div><div class="total">$0.00</div><button class="x">×</button>`;
 const sel=row.querySelector('.je-name');
 sel.addEventListener('change',()=>{let i=sel.value;if(i!==''){let e=expenseLib[i];row.querySelector('.je-rate').value=e.rate??'';row.querySelector('.je-qty').value=e.qty??1} calculate()});
 row.querySelectorAll('input').forEach(x=>x.addEventListener('input',calculate)); row.querySelector('.x').onclick=()=>{row.remove();calculate()}; $('jobExpenses').appendChild(row); calculate();
}
function matTotal(){let t=0;document.querySelectorAll('#jobMaterials .itemrow').forEach(r=>{let p=parseFloat(r.querySelector('.jm-pack').value)||0,c=parseFloat(r.querySelector('.jm-cost').value)||0,u=Math.max(0,Math.round(parseFloat(r.querySelector('.jm-used').value)||0)),v=p?c/p*u:0;r.querySelector('.total').textContent=money(v);t+=v});return t}
function expTotal(){let t=0;document.querySelectorAll('#jobExpenses .itemrow').forEach(r=>{let rate=parseFloat(r.querySelector('.je-rate').value)||0,q=parseFloat(r.querySelector('.je-qty').value)||0,v=rate*q;r.querySelector('.total').textContent=money(v);t+=v});return t}
function calculate(){
 let mats=matTotal(), hrs=n('prepHours')+n('buildHours')+n('installHours')+n('recoveryHours'), labor=hrs*n('workers')*n('laborRate'), exp=expTotal(), direct=mats+labor+exp;
 let oh=direct*(n('overhead')/100), cost=direct+oh, marginPct=Math.max(0,Math.min(n('margin'),100)), margin=marginPct/100;
 let raw=marginPct>=100 ? null : cost/(1-margin), profit=raw===null?null:raw-cost;
 let units=n('units'), floor=units*settings.minUnit, round=settings.roundTo||1;
 let rec=raw===null ? null : Math.max(raw,floor,settings.minJob);
 if(rec!==null) rec=Math.ceil(rec/round)*round;
 $('overheadValue').textContent=Math.round(n('overhead'))+'%';$('marginValue').textContent=Math.round(n('margin'))+'%';
 $('sMat').textContent=money(mats);$('sLabor').textContent=money(labor);$('sExp').textContent=money(exp);$('sDirect').textContent=money(direct);$('sOH').textContent=money(oh);$('sCost').textContent=money(cost);$('sProfit').textContent=profit===null?'—':money(profit);$('sRaw').textContent=raw===null?'No finite price':money(raw);$('recommended').textContent=rec===null?'—':money(rec).replace('.00','');
 $('perUnit').textContent=rec===null?'100% true profit margin is not mathematically finite':(units?`${money(rec/units)} per ${$('unitName').value}`:'Enter job size to see price per unit');
 let st=$('status');st.className='status'; if(!direct)st.textContent='Add your job details to begin.'; else if(marginPct>=100){st.classList.add('bad');st.textContent='100% true profit margin would require an infinite selling price. Slide below 100% to calculate a quote.'} else if((floor>raw||settings.minJob>raw)&&rec>raw){st.classList.add('warn');st.textContent='A Blown Away minimum-pricing guardrail increased this quote.'} else if(!n('margin')){st.classList.add('warn');st.textContent='No profit margin is set yet. This price currently covers cost/overhead only.'} else st.textContent='Target margin is protected. Review the scope before sending.';
 let finalInput=parseFloat($('finalQuote').value), finalPrice=Number.isFinite(finalInput)&&finalInput>=0?finalInput:rec;
 $('decisionRecommended').textContent=rec===null?'—':money(rec);
 $('decisionFinal').textContent=finalPrice===null?'—':money(finalPrice);
 let actualProfit=finalPrice===null?null:finalPrice-cost;
 let actualMargin=(finalPrice&&actualProfit!==null)?(actualProfit/finalPrice*100):0;
 $('decisionProfit').textContent=actualProfit===null?'—':money(actualProfit);
 $('decisionMargin').textContent=finalPrice===null?'—':actualMargin.toFixed(1)+'%';
 let os=$('overrideStatus');os.className='status';
 if(rec===null){os.classList.add('bad');os.textContent='Set the target profit margin below 100% before finalizing a quote.'}
 else if(!Number.isFinite(finalInput)){os.textContent='Final quote is using the calculator’s recommended price.'}
 else if(finalPrice<cost){os.classList.add('bad');os.textContent='Warning: this final quote is below Blown Away’s calculated cost.'}
 else if(finalPrice<rec){os.classList.add('warn');os.textContent='Employee override is below the recommended price. Review the reduced profit margin.'}
 else if(finalPrice>rec){os.textContent='Employee override is above the recommended price and improves expected profit.'}
 else os.textContent='Final quote matches the recommended price.';
 let client=$('client').value.trim(), size=units?`${units} ${$('unitName').value}`:''; $('quoteText').value=`${$('service').value}${size?' • '+size:''}\n${client?client+'\n':''}Custom balloon service based on the agreed design, scope, preparation and installation.\n\nCustomer Quote: ${finalPrice===null?'Set profit margin below 100%':money(finalPrice)}`;
}
window.printInternalWorksheet = function () {
  calculate();

  const val = id => {
    const el = document.getElementById(id);
    return el ? el.value : '';
  };

  const txt = id => {
    const el = document.getElementById(id);
    return el ? el.textContent : '';
  };

  const safe = value => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const serviceEl = document.getElementById('service');
  const unitEl = document.getElementById('unitName');

  const service = serviceEl
    ? serviceEl.options[serviceEl.selectedIndex]?.text || serviceEl.value
    : '';

  const unit = unitEl
    ? unitEl.options[unitEl.selectedIndex]?.text || unitEl.value
    : '';

  const materialRows = Array.from(
    document.querySelectorAll('#jobMaterials .itemrow')
  ).map(row => {
    const fields = row.querySelectorAll('select, input');
    const name = fields[0]
      ? (fields[0].options
          ? fields[0].options[fields[0].selectedIndex]?.text
          : fields[0].value)
      : '';

    const values = Array.from(fields)
      .slice(1)
      .map(field => field.value);

    return `
      <tr>
        <td>${safe(name)}</td>
        <td>${safe(values[0] || '')}</td>
        <td>${safe(values[1] || '')}</td>
        <td>${safe(values[2] || '')}</td>
      </tr>
    `;
  }).join('');

  const expenseRows = Array.from(
    document.querySelectorAll('#jobExpenses .itemrow')
  ).map(row => {
    const fields = row.querySelectorAll('select, input');
    const name = fields[0]
      ? (fields[0].options
          ? fields[0].options[fields[0].selectedIndex]?.text
          : fields[0].value)
      : '';

    const values = Array.from(fields)
      .slice(1)
      .map(field => field.value);

    return `
      <tr>
        <td>${safe(name)}</td>
        <td>${safe(values[0] || '')}</td>
        <td>${safe(values[1] || '')}</td>
      </tr>
    `;
  }).join('');

  const printWindow = window.open('', '_blank', 'width=900,height=800');

  if (!printWindow) {
    alert('Please allow pop-ups so the internal worksheet can open.');
    return;
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Blown Away Internal Pricing Worksheet</title>
      <style>
        @page {
          size: Letter portrait;
          margin: 0.4in;
        }

        * {
          box-sizing: border-box;
        }

        body {
          font-family: Arial, Helvetica, sans-serif;
          color: #171a1a;
          margin: 0;
          font-size: 11px;
          line-height: 1.3;
        }

        h1 {
          margin: 0;
          font-size: 22px;
        }

        h2 {
          font-size: 14px;
          margin: 14px 0 5px;
          border-bottom: 2px solid #0b4f52;
          padding-bottom: 3px;
        }

        .top {
          border-bottom: 4px solid #0b4f52;
          padding-bottom: 10px;
          margin-bottom: 10px;
        }

        .internal {
          font-size: 9px;
          font-weight: bold;
          margin-top: 4px;
        }

        .details,
        .summary {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4px 20px;
        }

        .line {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ddd;
          padding: 3px 0;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 4px;
        }

        th,
        td {
          border: 1px solid #ccc;
          padding: 4px 5px;
          text-align: left;
        }

        th {
          background: #f2f2f2;
        }

        .pricing {
          margin-top: 12px;
          border: 2px solid #0b4f52;
          padding: 9px;
        }

        .pricing .big {
          font-size: 16px;
          font-weight: bold;
        }

        .quote {
          white-space: pre-wrap;
          border: 1px solid #ccc;
          padding: 7px;
          margin-top: 5px;
        }

        .footer {
          margin-top: 12px;
          font-size: 8px;
        }
      </style>
    </head>

    <body>
      <div class="top">
        <h1>Blown Away by Gallery A</h1>
        <div>Internal Pricing Worksheet</div>
        <div class="internal">
          INTERNAL USE ONLY — Contains company cost, labor, overhead and profit information.
        </div>
      </div>

      <h2>Job Details</h2>
      <div class="details">
        <div class="line"><span>Client / Project</span><strong>${safe(val('client'))}</strong></div>
        <div class="line"><span>Event Date</span><strong>${safe(val('eventDate'))}</strong></div>
        <div class="line"><span>Setup Type</span><strong>${safe(service)}</strong></div>
        <div class="line"><span>Size / Quantity</span><strong>${safe(val('units'))} ${safe(unit)}</strong></div>
      </div>

      <h2>Materials</h2>
      <table>
        <thead>
          <tr>
            <th>Material</th>
            <th>Pack Qty</th>
            <th>Pack Cost</th>
            <th>Qty Used</th>
          </tr>
        </thead>
        <tbody>
          ${materialRows || '<tr><td colspan="4">No materials entered</td></tr>'}
        </tbody>
      </table>

      <h2>Labor</h2>
      <div class="summary">
        <div class="line"><span>Prep / Design Hours</span><strong>${safe(val('prepHours'))}</strong></div>
        <div class="line"><span>Build Hours</span><strong>${safe(val('buildHours'))}</strong></div>
        <div class="line"><span>Install Hours</span><strong>${safe(val('installHours'))}</strong></div>
        <div class="line"><span>Recovery Hours</span><strong>${safe(val('recoveryHours'))}</strong></div>
        <div class="line"><span>People</span><strong>${safe(val('workers'))}</strong></div>
        <div class="line"><span>Internal Hourly Rate</span><strong>$${safe(val('laborRate'))}</strong></div>
        <div class="line"><span>Total Labor</span><strong>${safe(txt('sLabor'))}</strong></div>
      </div>

      <h2>Other Expenses</h2>
      <table>
        <thead>
          <tr>
            <th>Expense</th>
            <th>Rate</th>
            <th>Qty / Days</th>
          </tr>
        </thead>
        <tbody>
          ${expenseRows || '<tr><td colspan="3">No expenses entered</td></tr>'}
        </tbody>
      </table>

      <h2>Cost & Pricing</h2>
      <div class="summary">
        <div class="line"><span>Materials</span><strong>${safe(txt('sMat'))}</strong></div>
        <div class="line"><span>Labor</span><strong>${safe(txt('sLabor'))}</strong></div>
        <div class="line"><span>Other Expenses</span><strong>${safe(txt('sExp'))}</strong></div>
        <div class="line"><span>Direct Job Cost</span><strong>${safe(txt('sDirect'))}</strong></div>
        <div class="line"><span>Overhead Allocation</span><strong>${safe(txt('sOH'))}</strong></div>
        <div class="line"><span>Cost Before Profit</span><strong>${safe(txt('sCost'))}</strong></div>
        <div class="line"><span>Target Profit</span><strong>${safe(txt('sProfit'))}</strong></div>
        <div class="line"><span>Calculated Selling Price</span><strong>${safe(txt('sRaw'))}</strong></div>
      </div>

      <div class="pricing">
        <div class="line big">
          <span>Recommended Price</span>
          <strong>${safe(txt('decisionRecommended'))}</strong>
        </div>
        <div class="line big">
          <span>Final Customer Quote</span>
          <strong>${safe(txt('decisionFinal'))}</strong>
        </div>
        <div class="line">
          <span>Expected Profit</span>
          <strong>${safe(txt('decisionProfit'))}</strong>
        </div>
        <div class="line">
          <span>Actual Profit Margin</span>
          <strong>${safe(txt('decisionMargin'))}</strong>
        </div>
      </div>

      <h2>Quote Summary</h2>
      <div class="quote">${safe(val('quoteText'))}</div>

      <div class="footer">
        Blown Away by Gallery A LLC — Internal Pricing Studio
      </div>

      <script>
        window.onload = function () {
          setTimeout(function () {
            window.print();
          }, 250);
        };
      <\/script>
    </body>
    </html>
  `);

  printWindow.document.close();
};

function loadDefaultExpenses(){$('jobExpenses').innerHTML='';expenseLib.forEach((e,i)=>{if(e.rate!=null&&e.qty!=null)addJobExpense({idx:i,rate:e.rate,qty:e.qty})});calculate()}
function renderMatLib(){
  $('materialLibrary').innerHTML='';

  materialLib.forEach((m,i)=>{
    let tr=document.createElement('tr');

    tr.innerHTML=`
      <td><input value="${m.name||''}" data-k="name"></td>
      <td><input type="number" min="0" step=".01" value="${m.pack??''}" data-k="pack"></td>
      <td><input type="number" min="0" step=".01" value="${m.cost??''}" data-k="cost"></td>
      <td>${m.pack&&m.cost?money(m.cost/m.pack):'—'}</td>
      <td><button class="x">×</button></td>
    `;

    tr.querySelectorAll('input').forEach(inp=>{
      inp.oninput=()=>{
        let k=inp.dataset.k;

        materialLib[i][k]=
          k==='name'
            ? inp.value
            : (inp.value==='' ? null : parseFloat(inp.value));

        let unitCell=tr.children[3];

        unitCell.textContent=
          (materialLib[i].pack && materialLib[i].cost)
            ? money(materialLib[i].cost/materialLib[i].pack)
            : '—';
      };
    });

    tr.querySelector('.x').onclick=()=>{
      materialLib.splice(i,1);
      renderMatLib();
    };

    $('materialLibrary').appendChild(tr);
  });
}

function renderExpLib(){
 $('expenseLibrary').innerHTML=''; expenseLib.forEach((e,i)=>{let tr=document.createElement('tr');let total=(e.rate!=null&&e.qty!=null)?e.rate*e.qty:null;tr.innerHTML=`<td><input value="${e.name||''}" data-k="name"></td><td><input type="number" min="0" step=".01" value="${e.rate??''}" data-k="rate"></td><td><input type="number" min="0" step=".01" value="${e.qty??''}" data-k="qty"></td><td>${total==null?'—':money(total)}</td><td><button class="x">×</button></td>`;tr.querySelectorAll('input').forEach(inp=>inp.oninput=()=>{
  let k=inp.dataset.k;
  expenseLib[i][k]=k==='name'?inp.value:(inp.value===''?null:parseFloat(inp.value));
  let totalCell=tr.children[3];
  let total=(expenseLib[i].rate!=null&&expenseLib[i].qty!=null)?expenseLib[i].rate*expenseLib[i].qty:null;
  totalCell.textContent=total==null?'—':money(total);
});tr.querySelector('.x').onclick=()=>{expenseLib.splice(i,1);renderExpLib()};$('expenseLibrary').appendChild(tr) })
}
function updateSettingSliderLabels(){$('defaultOverheadValue').textContent=Math.round(n('defaultOverhead'))+'%';$('defaultMarginValue').textContent=Math.round(n('defaultMargin'))+'%'}
function applySettings(){$('defaultLaborRate').value=settings.labor;$('defaultOverhead').value=settings.overhead;$('defaultMargin').value=settings.margin;$('minimumJob').value=settings.minJob;$('minimumUnit').value=settings.minUnit;$('roundTo').value=settings.roundTo;$('laborRate').value=settings.labor;$('overhead').value=settings.overhead;$('margin').value=settings.margin;updateSettingSliderLabels()}
function saveCurrentJob(){let data={client:$('client').value,eventDate:$('eventDate').value,service:$('service').value,units:$('units').value,unitName:$('unitName').value,prepHours:$('prepHours').value,buildHours:$('buildHours').value,installHours:$('installHours').value,recoveryHours:$('recoveryHours').value,workers:$('workers').value,laborRate:$('laborRate').value,overhead:$('overhead').value,margin:$('margin').value,finalQuote:$('finalQuote').value,materials:[...document.querySelectorAll('#jobMaterials .itemrow')].map(r=>({idx:r.querySelector('.jm-name').value,pack:r.querySelector('.jm-pack').value,cost:r.querySelector('.jm-cost').value,used:r.querySelector('.jm-used').value})),expenses:[...document.querySelectorAll('#jobExpenses .itemrow')].map(r=>({idx:r.querySelector('.je-name').value,rate:r.querySelector('.je-rate').value,qty:r.querySelector('.je-qty').value}))};localStorage.setItem('ba_currentJob_v2',JSON.stringify(data));let b=$('saveJob');b.textContent='Saved ✓';setTimeout(()=>b.textContent='Save current job',1200)}
function loadJob(){let d=JSON.parse(localStorage.getItem('ba_currentJob_v2')||'null');if(!d){addJobMaterial();return};['client','eventDate','service','units','unitName','prepHours','buildHours','installHours','recoveryHours','workers','laborRate','overhead','margin','finalQuote'].forEach(k=>{if(d[k]!=null&&$(k))$(k).value=d[k]});$('jobMaterials').innerHTML='';(d.materials||[]).forEach(addJobMaterial);if(!d.materials?.length)addJobMaterial();$('jobExpenses').innerHTML='';(d.expenses||[]).forEach(addJobExpense);calculate()}

$('addMat').onclick=()=>addJobMaterial();$('addExp').onclick=()=>addJobExpense();$('loadStandard').onclick=loadDefaultExpenses;$('saveJob').onclick=saveCurrentJob;
$('newJob').onclick=()=>{localStorage.removeItem('ba_currentJob_v2');location.reload()};
$('addLibraryMat').onclick=()=>{materialLib.push({name:'New Material',pack:null,cost:null,unit:null});renderMatLib()};
$('addLibraryExp').onclick=()=>{expenseLib.push({name:'New Expense',rate:null,qty:1});renderExpLib()};
$('saveLibraries').onclick=()=>{localStorage.setItem('ba_materialLib_v2',JSON.stringify(materialLib));alert('Material library saved.')};$('saveExpenses').onclick=()=>{localStorage.setItem('ba_expenseLib_v2',JSON.stringify(expenseLib));alert('Expense library saved.')};
$('saveSettings').onclick=()=>{settings={labor:n('defaultLaborRate'),overhead:n('defaultOverhead'),margin:n('defaultMargin'),minJob:n('minimumJob'),minUnit:n('minimumUnit'),roundTo:parseFloat($('roundTo').value)||1};localStorage.setItem('ba_settings_v2',JSON.stringify(settings));$('laborRate').value=settings.labor;$('overhead').value=settings.overhead;$('margin').value=settings.margin;calculate();alert('Business settings saved.')};
$('resetAll').onclick=()=>{if(confirm('Restore the original spreadsheet-derived defaults and clear saved V2 data?')){['ba_materialLib_v2','ba_expenseLib_v2','ba_settings_v2','ba_currentJob_v2'].forEach(k=>localStorage.removeItem(k));location.reload()}};
document.querySelectorAll('.calc,#client,#service,#units,#unitName,#finalQuote').forEach(e=>e.addEventListener('input',calculate));
['defaultOverhead','defaultMargin'].forEach(id=>$(id).addEventListener('input',updateSettingSliderLabels));
document.querySelectorAll('.tab').forEach(btn=>btn.onclick=()=>{document.querySelectorAll('.tab').forEach(b=>b.classList.remove('active'));btn.classList.add('active');['calculator','materials','expenses','settings'].forEach(t=>$(t+'Tab').classList.toggle('hidden',btn.dataset.tab!==t))});
applySettings();renderMatLib();renderExpLib();loadJob();calculate();

// Material quantities are physical items, so Qty Used is whole-number only.
document.addEventListener('change', function(e){
  if(e.target && e.target.matches('.jm-used')){
    const v = Math.max(0, Math.round(Number(e.target.value) || 0));
    e.target.value = v;
    calculate();
  }
});
}


  } catch(e) { console.error(e); }
})();
})();
